// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3oT-Z","info":"UpdateTermsInfo_info__1eeAy"};